export interface Secuencia {
    idAnuncio: number,
    idSecuencia: number,
    idGestor: number,
    txObservacion: string,
    bdEstado: string,
    dtSeguimiento: string,
    bdEstadoRegistro: boolean
}

export function GetVoidSecuencia(): Secuencia{
    return {
        idAnuncio: 0,
        idSecuencia: 0,
        idGestor: 0,
        txObservacion: '',
        bdEstado: '',
        dtSeguimiento: '',
        bdEstadoRegistro: false
    }
}